import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgEgypt = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M14.406 6.053a.75.75 0 0 0-.906.288l-3.62 5.177a.75.75 0 0 0-.088-.712c.003.004-1.168-1.68-1.234-1.772a.75.75 0 0 0-1.223.01l-5.2 7.45a.75.75 0 0 0 .615 1.178h2.685a.75.75 0 1 0 0-1.5H4.188l3.762-5.388.174.25c.227.327.42.607.448.644a.75.75 0 0 0 1.108.125l-3.28 4.69a.75.75 0 0 0 .615 1.18H21.25a.75.75 0 0 0 .614-1.18L14.744 6.32a.75.75 0 0 0-.338-.267m-5.951 10.12 4.052-5.794-1.36 5.794zm11.355 0h-7.123l1.79-7.62z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgEgypt;
